var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-2user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.313,
    height: 38.313,
    viewBox: "0 0 38.313 38.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H38.313V38.313H0Z",
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90826",
    "data-name": "Group 90826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.583,0a7.576,7.576,0,0,0-.192,15.149,1.288,1.288,0,0,1,.351,0h.112A7.577,7.577,0,0,0,7.583,0Z",
    transform: "translate(12 12)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "complete-svgrepo-com",
    d: "M12.35,18.963,7.3,13.91l1.149-1.149,3.9,3.9,7.486-7.488,1.149,1.151L12.35,18.963ZM13.872,0A13.816,13.816,0,1,0,27.687,13.816,13.831,13.831,0,0,0,13.872,0Z",
    transform: "translate(4.944 5)",
    fill: "#aeccc8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCompleted);
export default __webpack_public_path__ + "static/media/home-completed.7bf59f4afcbe66115b24fcf376a5b168.svg";
export { ForwardRef as ReactComponent };